import React from "react";
import _ from "lodash";
import ModalWrapper from "components/common/ModalWrapper";

class PreviewFeaturesAndSaveModal extends React.PureComponent {
  render() {
    const {
      finalConfig,
      isReviewModalOpened,
      handleCloseReviewModal,
      isSaving,
      saveErrMsg,
      handleConfirmSaveConfig,
    } = this.props;

    if (!isReviewModalOpened) return "";

    return (
      <ModalWrapper
        isOpen={isReviewModalOpened}
        showCloseFooter={false}
        handleClose={handleCloseReviewModal}
        customOverlayStyle={{ zIndex: 100 }}
        width="60%"
        title="Preview Features"
      >
        <div>
          <div
            className="border overflow-y-auto"
            style={{ maxHeight: "320px" }}
          >
            <pre>{JSON.stringify(finalConfig, null, 2)}</pre>
          </div>

          <div className="mt-4 flex flex-row-reverse items-center">
            <div>
              <button
                type="button"
                className="rounded shadow bg-blue-500 px-4 py-2 font-semibold text-white hover:bg-blue-700"
                onClick={handleConfirmSaveConfig}
              >
                {isSaving ? "Saving..." : "Confirm save"}
              </button>
            </div>
            <div>
              <button
                type="button"
                disabled={isSaving}
                className={`px-4 py-2 text-blue-700 ${
                  isSaving ? "cursor-not-allowed" : ""
                }`}
                onClick={handleCloseReviewModal}
              >
                Cancel
              </button>
            </div>
            <div className="text-red-600">{saveErrMsg}</div>
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default PreviewFeaturesAndSaveModal;
